import { useState, useEffect, useRef } from 'react'
import { useGetRecommendationLazyQuery } from '../gql/graphql'
import useCookie from './useCookie'
import useUtente from './useUtente'

export function useRecommendation(prodotto) {
  const [recommendedForYou, setRecommendedForYou] = useState([])
  const { utente, loading: utenteLoading } = useUtente()

  const [getRecommendation] = useGetRecommendationLazyQuery({
    onCompleted: (data) => {
      setRecommendedForYou(data?.getRecommendation || [])
    },
  })

  const [cookieValue] = useCookie('_ga', '')
  const [lastProductViewed] = useCookie('lastProductViewed', '')

  const hasFetchedRecommendations = useRef(false)

  useEffect(() => {
    if (
      !utenteLoading &&
      !hasFetchedRecommendations.current &&
      (utente?.pk?.toString() || cookieValue?.split('.').slice(2).join('.'))
    ) {
      const userId = utente ? utente.pk.toString() : cookieValue?.split('.').slice(2).join('.')
      getRecommendation({
        variables: {
          userId,
          productSku: prodotto ? prodotto.codice : lastProductViewed,
        },
      })
      hasFetchedRecommendations.current = true
    }
  }, [utenteLoading, utente?.pk, cookieValue, prodotto?.codice, getRecommendation])

  return {
    recommendedForYou,
  }
}
